<template>
  <div style="padding: 10px">
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      @click="openEditQQGroupDialog(true)"
      >添加QQ群</el-button
    >

    <el-table :data="qqGroupTableData" border size="small" style="width: 920px">
      <el-table-column
        prop="channelName"
        label="渠道"
        align="center"
        width="100"
      >
      </el-table-column>
      <el-table-column prop="name" label="群名称" align="center" width="220">
      </el-table-column>
      <el-table-column prop="number" label="群号" align="center" width="100">
      </el-table-column>
      <el-table-column prop="order" label="顺序" align="center" width="50">
      </el-table-column>
      <el-table-column prop="addKey" label="加群key" align="center" width="300">
      </el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template scope="scope">
          <el-button
            type="danger"
            round
            size="small"
            @click="deleteQQGroup(scope.row.id, scope.row.name)"
            >删除</el-button
          >
          <el-button
            type="primary"
            round
            size="small"
            @click="openEditQQGroupDialog(false, scope.row)"
            >修改</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- “添加/修改QQ群”对话框 -->
    <EditQQGroupDialog
      v-if="shouldEditQQGroupDialogVisible"
      @close="onEditQQGroupDialogClosed()"
      :value="valueForEditQQGroupDialog"
    ></EditQQGroupDialog>
  </div>
</template>

<script>
const axios = require("axios");
import util from "@/util";
import bizutil from "@/bizutil";

import EditQQGroupDialog from "./EditQQGroupDialog";

export default {
  data() {
    return {
      availableChannels: [], // 所有可用的渠道
      shouldEditQQGroupDialogVisible: false, // “添加/修改QQ群”对话框是否应该显示出来
      valueForEditQQGroupDialog: null, // 要传递给“添加/修改QQ群”对话框的数据
      qqGroupTableData: [], // qq群列表里展示的数据
    };
  },

  async created() {
    // 拉取渠道集合
    await this.loadAvailableChannels();

    this.loadQQGroupList();
  },

  components: {
    EditQQGroupDialog,
  },

  methods: {
    /**
     * 拉取渠道集合
     */
     async loadAvailableChannels() {
      this.availableChannels = await bizutil.loadAvailableChannels();
    },

    /**
     * 查询QQ群集合
     */
    async loadQQGroupList() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/api/admin/v1/qq/getList`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        // 可能需要重新登录
        if (resData.code == 10019 || resData.code == 10020) {
          util.gotoLoginPage();
          return;
        }

        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      let qqGroupList = resData.data.qqGroups || [];

      // 排序
      qqGroupList.sort((x, y) => {
        if (x.channelId == y.channelId) {
          return y.order - x.order;
        } else {
          return x.channelId - y.channelId;
        }
      });

      this.qqGroupTableData = qqGroupList;

      // 补上渠道名称
      for (let e of this.qqGroupTableData) {
        for (let c of this.availableChannels) {
          if (c.id == e.channelId) {
            e.channelName = c.name;
            break;
          }
        }
      }      
    },

    /**
     * 删除一个QQ群
     */
    async deleteQQGroup(qqGroupId, qqGroupName) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除QQ群“${qqGroupName}”？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/api/admin/v1/qq/delete`,
            {
              id: qqGroupId,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          // 可能需要重新登录
          if (resData.code == 10019 || resData.code == 10020) {
            util.gotoLoginPage();
            return;
          }

          this.$message({
            message: resData.message,
            type: "error",
          });
          return;
        }

        // 重新拉QQ群集合
        return this.loadQQGroupList();
      } catch (e) {}
    },

    /**
     * 打开“添加/修改QQ群”对话框
     */
    async openEditQQGroupDialog(isCreate, oldData) {
      this.shouldEditQQGroupDialogVisible = true;
      this.valueForEditQQGroupDialog = {
        isCreate: isCreate,
        oldData: oldData,
      };
    },

    /**
     * “添加/修改QQ群”对话框关闭了
     */
    async onEditQQGroupDialogClosed() {
      this.shouldEditQQGroupDialogVisible = false;

      // 重新拉QQ群集合
      return this.loadQQGroupList();
    },
  },
};
</script>